'use strict';

service.$inject = ["localStorageService", "dateService", "dataAvailabilityService", "companyService", "FORMAT"];
app.service('dateRangeService', service);

function service(localStorageService, dateService, dataAvailabilityService, companyService, FORMAT) {
  var _this = this;

  var userInfo = localStorageService.get('userInfo');
  var today = moment().startOf('day');
  var thisYearFiscalEnd = getThisYearFiscalEnd();
  var lastYearFiscalEnd = getLastYearFiscalEnd();
  var isPeriodsMode = localStorageService.get('userInfo').company.is13periods;
  var analyticCloseDate = dataAvailabilityService.getAnalyticsCloseDate();
  if (analyticCloseDate) {
    // check if analyticCloseDate is the same as EndOfMonth
    if (moment(analyticCloseDate).endOf('month').isSame(analyticCloseDate, 'day')) {
      var latestAvailableMonth = moment(analyticCloseDate).startOf('month');
    } else {
      var latestAvailableMonth = moment(analyticCloseDate).subtract(1, 'month').startOf('month');
    }
  } else {
    // check if today is the same as EndOfMonth
    if (moment().endOf('month').isSame(moment(), 'day')) {
      var latestAvailableMonth = moment().startOf('month');
    } else {
      var latestAvailableMonth = moment().subtract(1, 'month').startOf('month');
    }
  }


  var defaultDateRanges = {
    'today': {
      caption: 'Today',
      start: angular.copy(today),
      end: angular.copy(today)
    },
    'last7': {
      caption: 'Last 7 Days',
      start: angular.copy(today).subtract(7, 'days'),
      end: angular.copy(today)
    },
    'last30': {
      caption: 'Last 30 Days',
      start: angular.copy(today).subtract(30, 'days'),
      end: angular.copy(today)
    },
    'last60': {
      caption: 'Last 60 Days',
      start: angular.copy(today).subtract(60, 'days'),
      end: angular.copy(today)
    },
    'last90': {
      caption: 'Last 90 Days',
      start: angular.copy(today).subtract(90, 'days'),
      end: angular.copy(today)
    },
    'lastMonth': {
      // caption: 'Last Month',
      caption: angular.copy(today).subtract(1, 'month').startOf('month').format('MMMM'),
      start: angular.copy(today).subtract(1, 'month').startOf('month'),
      end: angular.copy(today).subtract(1, 'month').endOf('month').startOf('day')
    },
    'lastYear': {
      caption: 'Last 12 month',
      start: angular.copy(today).subtract(1, 'year').add(1, 'days'),
      end: angular.copy(today)
    },
    'all': {
      caption: 'All Dates',
      start: moment(userInfo.currentStore.dataStartDate).startOf('day').subtract(1, 'week'),
      end: moment().add(100, 'year')
    },
    'thisWeek': {
      // caption: 'This Week',
      caption: 'Week ' + dateService.getWeekStartOfDate(moment()).format('MM/DD/YY'),
      start: dateService.getWeekStartOfDate(moment()),
      end: angular.copy(today)
    },
    'thisMonth': {
      // caption: 'This Month',
      caption: moment().startOf('month').format('MMMM'),
      start: moment().startOf('month'),
      end: angular.copy(today)
    },
    'thisYear': {
      caption: today.format('YYYY'),
      start: moment().startOf('year'),
      end: angular.copy(today)
    },
    'thisYearFiscal': {
      caption: thisYearFiscalEnd.format('YYYY'),
      start: angular.copy(thisYearFiscalEnd).subtract(1, 'year').add(1, 'days'),
      end: angular.copy(thisYearFiscalEnd)
    },
    'lastYearFiscal': {
      caption: lastYearFiscalEnd.format('YYYY'),
      start: angular.copy(lastYearFiscalEnd).subtract(1, 'year').add(1, 'days'),
      end: angular.copy(lastYearFiscalEnd)
    },
    'latestAvailableMonth': {
      caption: latestAvailableMonth.format('MMMM'),
      start: angular.copy(latestAvailableMonth).startOf('month'),
      end: angular.copy(latestAvailableMonth).endOf('month')
    },
    'monthBeforeLatestAvailableMonth': {
      caption: angular.copy(latestAvailableMonth).subtract(1, 'month').format('MMMM'),
      start: angular.copy(latestAvailableMonth).subtract(1, 'month').startOf('month'),
      end: angular.copy(latestAvailableMonth).subtract(1, 'month').endOf('month')
    },
    'thisYearAvailable': {
      caption: latestAvailableMonth.format('YYYY'),
      start: angular.copy(latestAvailableMonth).startOf('year'),
      end: angular.copy(latestAvailableMonth).endOf('month')
    }
  };

  if (isPeriodsMode) {
    var thisYearPeriods = dateService.getYearPeriod(moment());
    var lastYearPeriods = dateService.getYearPeriod(moment(thisYearPeriods.start).subtract(1, 'month'));
    var thisPeriodStart = dateService.getPeriodFirstDay(moment().startOf('day'));
    var thisPeriodEnd = dateService.getPeriodEnd(thisPeriodStart);
    var lastPeriodEnd = moment(thisPeriodStart).subtract(1, 'day');
    var lastPeriodStart = dateService.getPeriodFirstDay(moment(lastPeriodEnd));

    if (analyticCloseDate) {
      var latestPeriodStart = dateService.getPeriodFirstDay(moment(analyticCloseDate).startOf('day'));
      var latestPeriodEnd = dateService.getPeriodEnd(latestPeriodStart);
      // if analyticCloseDate is not last day in period, we show previous period
      if (!moment(latestPeriodEnd).isSame(analyticCloseDate, 'day')) {
        latestPeriodStart = moment(latestPeriodStart).add(-4, 'weeks');
        latestPeriodEnd = moment(latestPeriodEnd).add(-4, 'weeks');
      }
      var yearPeriod = dateService.getYearPeriod(analyticCloseDate);
      var daysPassed = dateService.diffWithoutDST(yearPeriod.start, latestPeriodEnd);
      var latestPeriodNumber = Math.abs(Math.ceil(daysPassed / 28));
      if (latestPeriodNumber == 0) {
        latestPeriodNumber = 13;
      }

      var periodBeforeLatestStart = moment(latestPeriodStart).subtract(4, 'weeks');
      var periodBeforeLatestEnd = moment(latestPeriodEnd).subtract(4, 'weeks');
      var periodBeforeLatestNumber = latestPeriodNumber - 1;
      if (periodBeforeLatestNumber == 0) {
        periodBeforeLatestNumber = 13;
      }
    }

    _.assign(defaultDateRanges, {
      thisPeriod: {
        caption: 'This Period',
        start: thisPeriodStart,
        end: thisPeriodEnd
      },
      lastPeriod: {
        caption: 'Last Period',
        start: lastPeriodStart,
        end: lastPeriodEnd
      },
      thisYearPeriods: {
        caption: 'This Year (Periods)',
        start: thisYearPeriods.start,
        end: angular.copy(today)
      },
      lastYearPeriods: {
        caption: 'Last Year (Periods)',
        start: lastYearPeriods.start,
        end: lastYearPeriods.end
      },
      latestPeriod: {
        caption: 'Period #' + latestPeriodNumber,
        start: latestPeriodStart,
        end: latestPeriodEnd
      },
      periodBeforeLatest: {
        caption: 'Period #' + periodBeforeLatestNumber,
        start: periodBeforeLatestStart,
        end: periodBeforeLatestEnd
      },
      thisYearAvailablePeriods: {
        caption: 'This Year (Periods)',
        start: angular.copy(thisYearPeriods.start),
        end: angular.copy(latestPeriodEnd)
      },
      lastYearPeriods13: {
        caption: 'Last Year (Periods)',
        start: lastYearPeriods.start,
        end: lastYearPeriods.end.startOf('month')
      }
    });
  }

  this.getDateRange = function () {
    var currentYearPeriodsPromise = companyService.get13thPeriodDates(userInfo.currentStore.id);
    var companyPeriodsPromise = companyService.getCompanyPeriods(userInfo.currentStore.id);
    // eslint-disable-next-line no-undef
    return Promise.all([companyPeriodsPromise, currentYearPeriodsPromise]).then(function (values) {
      var result = [];
      values.forEach(function (elem) {
        result.push(elem.data);
      });
      result = _.uniqBy(result[0].concat(result[1]), function (p) {
        return p.periodStartString;
      });
      var currentPeriodDate = userInfo.role > 1 ? moment() : moment(userInfo.currentStore.analyticCloseDate);
      var currentPeriod = result.filter(function (elem, index) {
        if (moment(elem.periodEndString).isAfter(currentPeriodDate)) {
          elem.index = index;
          return elem;
        }
      })[0];
      var thisYearStart = currentPeriod.index < 13 ? result[0] : result[result.length - 13];
      var lastPeriod = result[currentPeriod.index - 2];
      var defaultDateRangesArr = currentPeriod.index > 12 ? [
        {
          caption: 'This Year (Periods)',
          start: moment(thisYearStart.periodStartString),
          end: userInfo.role === 2 ? moment(currentPeriod.periodStartString).subtract('1', 'day') : moment(currentPeriod.periodStartString).subtract('1', 'day')
        },
        {
          caption: 'Last Year (Periods)',
          // eslint-disable-next-line max-len,no-nested-ternary
          start: result.length > 27 ? moment(result[result.length - 26].periodStartString) : moment(result[0].periodStartString),
          // eslint-disable-next-line max-len,no-nested-ternary
          end: result.length > 27 ? moment(result[result.length - 14].periodEndString) : moment(result[12].periodEndString)
        },
        {
        // eslint-disable-next-line max-len
          caption: 'Period ' + (currentPeriod.period - 1),
          start: moment(lastPeriod.periodEndString).add('1', 'day'),
          // eslint-disable-next-line max-len
          end: userInfo.role === 2 ? moment(currentPeriod.periodStartString).subtract('1', 'day') : moment(currentPeriod.periodStartString).subtract('1', 'day')
        },
        {
          caption: 'Period ' + lastPeriod.period,
          start: moment(lastPeriod.periodStartString),
          end: moment(lastPeriod.periodEndString)
        }
      ] : [
        {
          caption: 'This Year (Periods)',
          start: moment(thisYearStart.periodStartString),
          end: moment(currentPeriod.periodEndString)
        },
        { caption: 'Period ' + (currentPeriod.period - 1),
          start: moment(lastPeriod.periodEndString).add('1', 'day'),
          // eslint-disable-next-line max-len
          end: userInfo.role === 2 ? moment(currentPeriod.periodStartString).subtract('1', 'day') : moment(currentPeriod.periodEndString)
        },
        {
          caption: 'Period ' + lastPeriod.period,
          start: moment(lastPeriod.periodStartString),
          end: moment(lastPeriod.periodEndString)
        }
      ];

      return [{
        start: moment(lastPeriod.periodEndString).add('1', 'day'),
        startDate: moment(lastPeriod.periodEndString).add('1', 'day'),
        // eslint-disable-next-line max-len
        end: userInfo.role === 2 ? moment(currentPeriod.periodStartString).subtract('1', 'day') : moment(currentPeriod.periodStartString).subtract('1', 'day'),
        // eslint-disable-next-line max-len
        endDate: userInfo.role === 2 ? moment(currentPeriod.periodStartString).subtract('1', 'day') : moment(currentPeriod.periodStartString).subtract('1', 'day')
        // eslint-disable-next-line max-len
      }, defaultDateRangesArr];
    });
  };

  this.getRanges = function (dateRangeTypes) {
    /*
      accepts:
        dateRangeTypes - array of keys for defaultDateRanges
      returns:
        array of default date ranges
    */
    return _.map(dateRangeTypes, _this.getRange);
  };

  this.getRange = function (rangeType) {
    /*
      accepts:
        rangeType - a keys for defaultDateRanges
      returns:
        dateRange
    */
    return _.clone(defaultDateRanges[rangeType]);
  };

  function getThisYearFiscalEnd() {
    var fiscalYearEnd = userInfo.company && userInfo.company.fiscalYear;  // to group by year
    return moment().months(fiscalYearEnd).endOf('month').startOf('day');
  }

  function getLastYearFiscalEnd() {
    var end = angular.copy(thisYearFiscalEnd);
    if (!end.isBefore(today)) {
      end.subtract(1, 'year').endOf('month').startOf('day');  // 29 Feb
    }
    return end;
  }

  this.getLastAllowedDateOrWeekEnd = function () {
    var lastDate = dataAvailabilityService.getLastAllowedDate();
    lastDate = (lastDate ? moment(lastDate) : moment()).startOf('day');
    var lastDateWeekStart = dateService.getWeekStartOfDate(angular.copy(lastDate));
    var lastDateWeekEnd = lastDateWeekStart.add(6, 'days').startOf('day');
    if (lastDateWeekEnd.isAfter(lastDate)) {
      lastDate = lastDateWeekEnd.subtract(7, 'days');
    }

    return lastDate;
  };

  this.getLastAllowedDateOrMonthEnd = function () {
    var lastDate = dataAvailabilityService.getLastAllowedDate();
    if (lastDate) return moment(lastDate);
    return moment().startOf('month').subtract(1, 'day');
  };

  this.getLastAllowedMonthRange = function () {
    var lastMonthEnd = this.getLastAllowedDateOrMonthEnd();
    return {
      start: moment(lastMonthEnd).startOf('month'),
      end: lastMonthEnd
    };
  };

  this.getLastAllowedYearRange = function () {
    var yearEnd = this.getLastAllowedDateOrMonthEnd();
    var yearStart = moment(yearEnd).startOf('year');
    var dataStartDate = moment(userInfo.currentStore.dataStartDate);
    if (dataStartDate.isAfter(yearStart)) {
      yearStart = dataStartDate.add(1, 'month').startOf('month');
    }

    return {
      start: yearStart,
      end: yearEnd
    };
  };

  this.getLastAllowedFourMonth = function () {
    var lastDate = dataAvailabilityService.getLastAllowedDate();
    lastDate = (lastDate ? moment(lastDate) : moment()).startOf('day');
    var endOfMonth = angular.copy(lastDate).endOf('month').startOf('day');
    if (endOfMonth.isAfter(lastDate)) {
      lastDate = endOfMonth.subtract(1, 'month').endOf('month').startOf('day');
    }
    var firstDate = moment(userInfo.currentStore.dataStartDate);
    if (!firstDate.isSame(angular.copy(firstDate).startOf('month'), 'day')) {
      firstDate = firstDate.add(1, 'month').startOf('month');
    }
    return {
      start: moment.max(angular.copy(lastDate).subtract(3, 'month').startOf('month'), firstDate),
      end: lastDate
    };
  };
}



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/dateRangeSelector/service.js